import React from "react";

interface CheckedCircleIconProps {
  className?: string;
  onClick?: () => void;
}

export const CheckedCircleIcon = ({
  className,
  onClick,
}: CheckedCircleIconProps) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M3.1875 3.46484C4.51823 2.13411 6.1224 1.46875 8 1.46875C9.8776 1.46875 11.4727 2.13411 12.7852 3.46484C14.1159 4.77734 14.7812 6.3724 14.7812 8.25C14.7812 10.1276 14.1159 11.7318 12.7852 13.0625C11.4727 14.375 9.8776 15.0312 8 15.0312C6.1224 15.0312 4.51823 14.375 3.1875 13.0625C1.875 11.7318 1.21875 10.1276 1.21875 8.25C1.21875 6.3724 1.875 4.77734 3.1875 3.46484ZM8 14.1562C9.64062 14.1562 11.0352 13.582 12.1836 12.4336C13.332 11.2669 13.9062 9.8724 13.9062 8.25C13.9062 6.60938 13.3229 5.21484 12.1562 4.06641C11.0078 2.91797 9.6224 2.34375 8 2.34375C6.35938 2.34375 4.96484 2.92708 3.81641 4.09375C2.66797 5.24219 2.09375 6.6276 2.09375 8.25C2.09375 9.89062 2.66797 11.2852 3.81641 12.4336C4.98307 13.582 6.3776 14.1562 8 14.1562ZM11.8828 6.63672L6.93359 11.5312C6.78776 11.6953 6.63281 11.6953 6.46875 11.5312L4.11719 9.15234C3.97135 9.00651 3.97135 8.85156 4.11719 8.6875L4.36328 8.46875C4.50911 8.32292 4.66406 8.32292 4.82812 8.46875L6.71484 10.3828L11.1719 5.92578C11.3359 5.77995 11.4909 5.78906 11.6367 5.95312L11.8828 6.17188C12.0286 6.33594 12.0286 6.49089 11.8828 6.63672Z"
      fill="#0C843C"
    />
  </svg>
);

CheckedCircleIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
